module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "row-bg p-10 mt-10 bg-lightgarg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    staticClass: "mr-10",
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Trip",
      "loading": _vm.loading,
      "loading-text": "loading...",
      "no-match-text": "No data",
      "no-data-text": "No data"
    },
    on: {
      "change": _vm.tripSelectList,
      "visible-change": _vm.showTripList
    },
    model: {
      value: (_vm.selectTripValue),
      callback: function($$v) {
        _vm.selectTripValue = $$v
      },
      expression: "selectTripValue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticClass: "input-setMaxWidth",
    attrs: {
      "placeholder": "Search anything about users"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleIconClick.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.handleIconClick
    },
    slot: "suffix"
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": require('../../assets/epq_forms1-13.docx')
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_c('i', {
    staticClass: "icon ion-android-download"
  }), _vm._v(" EPQ offline document")])], 1)])])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "mt-20",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "empty-text": "No data",
      "data": _vm.MyStudents,
      "element-loading-text": _vm.loadingText,
      "expand-row-keys": _vm.expandRowKeys,
      "row-key": _vm.getRowKey
    },
    on: {
      "expand-change": _vm.getExpand
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand",
      "prop": "id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tabs', {
          attrs: {
            "type": "border-card"
          },
          on: {
            "tab-click": function($event) {
              return _vm.getStuReport($event, props.$index, props.row)
            }
          }
        }, [_c('el-tab-pane', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (props.row.loadingReport),
            expression: "props.row.loadingReport"
          }],
          attrs: {
            "label": "EPQ",
            "element-loading-text": "loading..."
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_vm._l((_vm.MyStudents[props.$index].reportC.skillList), function(skill, index) {
          return _c('el-form-item', {
            key: index,
            attrs: {
              "label": skill.abbr
            }
          }, _vm._l((skill.pageList), function(page, index) {
            return _c('el-button-group', {
              key: index,
              staticClass: "pt-7"
            }, [_c('el-button', {
              key: index,
              staticClass: "p-5",
              class: page.confirmed == null ? 'info' : page.confirmed ? 'success' : 'primary',
              attrs: {
                "plain": "",
                "icon": "el-icon-edit-outline"
              },
              on: {
                "click": function($event) {
                  _vm.showPage(skill, page.page, page.id, props.$index, 'epq')
                }
              }
            }), _vm._v(" "), _c('router-link', {
              staticClass: "white mr-10",
              attrs: {
                "target": "_blank",
                "to": {
                  path: 'evidence',
                  query: {
                    studentId: props.row.id,
                    studentName: (props.row.displayName + ' ' + props.row.givenName + ' ' + props.row.familyName),
                    pageId: page.id,
                    skillAbbr: skill.abbr,
                    skillName: skill.name,
                    pageName: page.page,
                    reportId: props.row.reportC.id,
                    reportName: props.row.reportC.category,
                    reportIndex: _vm.$route.path
                  }
                },
                "append": ""
              }
            }, [_c('el-button', {
              staticClass: "p-evidence",
              attrs: {
                "plain": ""
              }
            }, [_c('i', {
              staticClass: "icon ion-folder",
              class: page.evidenceConfirmed == null ? 'info' : page.evidenceConfirmed ? 'success' : 'primary'
            })])], 1)], 1)
          }), 1)
        }), _vm._v(" "), _c('el-form-item', {
          staticClass: "full-width"
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.download(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "icon ion-shuffle mt-none"
        }), _vm._v(" Generate Report (PDF)\n                                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.downloadDocx(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "icon ion-shuffle mt-none"
        }), _vm._v(" Generate Report (DOCX)\n                                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "success",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.preview(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "icon el-icon-picture-outline"
        }), _vm._v(" Report Preview\n                                    ")])], 1)], 2)], 1), _vm._v(" "), _c('el-tab-pane', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (props.row.loadingReport),
            expression: "props.row.loadingReport"
          }],
          attrs: {
            "label": "LOG",
            "element-loading-text": "loading..."
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, _vm._l((_vm.MyStudents[props.$index].report.skillList), function(skill, index) {
          return _c('el-form-item', {
            key: index,
            staticClass: "log",
            attrs: {
              "label": skill.abbr
            }
          }, _vm._l((skill.pageList), function(page, index) {
            return _c('el-button-group', {
              key: index,
              staticClass: "pt-7"
            }, [_c('el-button', {
              key: index,
              staticClass: "p-5",
              attrs: {
                "plain": "",
                "icon": "el-icon-edit-outline"
              },
              on: {
                "click": function($event) {
                  _vm.showPage(skill, page.page, page.id, props.$index, 'log')
                }
              }
            })], 1)
          }), 1)
        }), 1)], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Name",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.displayName + ' - ' + scope.row.givenName + '  ' + scope.row.familyName))]), _vm._v(" "), _c('router-link', {
          attrs: {
            "to": {
              path: '/notification',
              query: {
                studentId: scope.row.id,
                studentName: (scope.row.displayName + ' - ' + scope.row.givenName + '  ' + scope.row.familyName)
              }
            },
            "target": "_blank"
          }
        }, [_c('el-badge', {
          attrs: {
            "value": _vm.role === 'teacher' || _vm.role === 'ta' ? scope.row.notificationCount : 0,
            "hidden": scope.row.notificationCount === 0
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Affiliation",
      "prop": "school",
      "min-width": "190"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "deadline1",
      "prop": "deadline1",
      "min-width": "190"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "deadline2",
      "prop": "deadline2",
      "min-width": "190"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Terms",
      "prop": "trip"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-50"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.size,
      "current-page": _vm.currentPageTable,
      "page-count": _vm.totalPages
    },
    on: {
      "current-change": _vm.pageCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit User",
      "visible": _vm.Editdialog,
      "customClass": "dialogStyle"
    },
    on: {
      "update:visible": function($event) {
        _vm.Editdialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "editform",
    attrs: {
      "model": _vm.editform,
      "rules": _vm.editrules,
      "label-width": "145px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email Address",
      "prop": "Eemail"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email Address"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.Eemail),
      callback: function($$v) {
        _vm.$set(_vm.editform, "Eemail", $$v)
      },
      expression: "editform.Eemail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item-default",
    attrs: {
      "label": "Change Password",
      "prop": "checked"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.changePass
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("Change Password")])], 1), _vm._v(" "), (_vm.willshow) ? [_c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "Epassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Password should contain 8 to 20 characters."
    },
    model: {
      value: (_vm.editform.Epassword),
      callback: function($$v) {
        _vm.$set(_vm.editform, "Epassword", $$v)
      },
      expression: "editform.Epassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Confirm Password",
      "prop": "EconfirmPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password"
    },
    model: {
      value: (_vm.editform.EconfirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EconfirmPassword", $$v)
      },
      expression: "editform.EconfirmPassword"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Given Name",
      "prop": "EgivenName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Given Name"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EgivenName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EgivenName", $$v)
      },
      expression: "editform.EgivenName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Family Name",
      "prop": "EfamilyName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Family Name"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EfamilyName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EfamilyName", $$v)
      },
      expression: "editform.EfamilyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Display Name",
      "prop": "EdisplayName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Display Name"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EdisplayName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EdisplayName", $$v)
      },
      expression: "editform.EdisplayName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "School",
      "prop": "Eschool"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Affiliation"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.Eschool),
      callback: function($$v) {
        _vm.$set(_vm.editform, "Eschool", $$v)
      },
      expression: "editform.Eschool"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Trips",
      "prop": "trip"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "no-match-text": "No data",
      "no-data-text": "No data",
      "placeholder": "Please select trip",
      "visible-change": "getTrip"
    },
    on: {
      "change": function($event) {
        _vm.isTripDirty = true
      }
    },
    model: {
      value: (_vm.dialogtripid),
      callback: function($$v) {
        _vm.dialogtripid = $$v
      },
      expression: "dialogtripid"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mobile Phone",
      "prop": "EmobilePhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mobile Phone"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EmobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EmobilePhone", $$v)
      },
      expression: "editform.EmobilePhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Father Phone",
      "prop": "EfatherPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Father Phone"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EfatherPhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EfatherPhone", $$v)
      },
      expression: "editform.EfatherPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mother Phone",
      "prop": "EmotherPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mother Phone"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EmotherPhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EmotherPhone", $$v)
      },
      expression: "editform.EmotherPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Deadline1",
      "prop": "EDeadline1"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "picker-options": _vm.pickerOptions,
      "placeholder": "Please select deadline"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EDeadline1),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EDeadline1", $$v)
      },
      expression: "editform.EDeadline1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Deadline2",
      "prop": "EDeadline2"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "picker-options": _vm.pickerOptions,
      "placeholder": "Please select deadline"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EDeadline2),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EDeadline2", $$v)
      },
      expression: "editform.EDeadline2"
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.Editdialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveBtnIsLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitedit('editform')
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Generate Report",
      "visible": _vm.showReportDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showReportDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "inline": "",
      "label-position": "right",
      "label-width": "130px"
    },
    model: {
      value: (_vm.reportDialogParam),
      callback: function($$v) {
        _vm.reportDialogParam = $$v
      },
      expression: "reportDialogParam"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "15px",
      "color": "#C0C4CC"
    }
  }, [_c('el-col', [_c('span', [_vm._v("This will be used to sign the check list and all the pages, leave empty if you don't want to sign.")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "Assessor"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.reportDialogParam.assessor),
      callback: function($$v) {
        _vm.$set(_vm.reportDialogParam, "assessor", $$v)
      },
      expression: "reportDialogParam.assessor"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "Internal Moderator"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.reportDialogParam.moderator),
      callback: function($$v) {
        _vm.$set(_vm.reportDialogParam, "moderator", $$v)
      },
      expression: "reportDialogParam.moderator"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showReportDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveBtnIsLoading
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.student, _vm.reportDialogParam.category)
      }
    }
  }, [_vm._v("OK")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.configSkillDialogLoading),
      expression: "configSkillDialogLoading"
    }],
    attrs: {
      "title": _vm.configSkillTitle,
      "visible": _vm.configSkillDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.configSkillDialog = $event
      }
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "max": 3,
      "min": 1
    },
    on: {
      "change": _vm.changeCheckedSkill
    },
    model: {
      value: (_vm.checkedSkillsName),
      callback: function($$v) {
        _vm.checkedSkillsName = $$v
      },
      expression: "checkedSkillsName"
    }
  }, [_c('div', {
    staticClass: "configAope"
  }, _vm._l((_vm.allAopeSkills), function(skill) {
    return _c('el-checkbox', {
      key: skill.id,
      attrs: {
        "label": skill.name
      }
    }, [_vm._v(_vm._s(skill.name))])
  }), 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.configSkillDialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitAopeSkillLoading
    },
    on: {
      "click": _vm.submitAopeSkill
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('skill-dialog', {
    ref: "reportDialog",
    attrs: {
      "report": _vm.report
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "generate-link"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c240832"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/teacher/Progress.vue
// module id = 618
// module chunks = 1